import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { LOYALTY_BENEFITS_PAGE_PATH } from "utils/constants/paths";

const LoyaltyBenefitsPage = Loadable(React.lazy(() => import("./View")));

export const LoyaltyBenefitsRoute: IRouteItem = {
  path: LOYALTY_BENEFITS_PAGE_PATH,
  element: React.createElement(LoyaltyBenefitsPage),
  name: "Loyalty Benefits",
};
